module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group--three-columns"
  }, [_c('ul', _vm._l((_vm.minimumOrderCoinRollsSettings), function(item, index) {
    return _c('li', [_c('div', {
      staticClass: "form-row"
    }, [_c('h4', [_vm._v(_vm._s(item.bank))]), _vm._v(" "), _c('p', {
      staticClass: "linc-text"
    }, [_vm._v(_vm._s(_vm.$t('management.unit.softwaresettings.minimumOrderPanel.min')))]), _vm._v(" "), _c('el-input', {
      staticClass: "linc-minimum-order-input",
      attrs: {
        "type": "number",
        "min": "1",
        "max": "200",
        "disabled": !_vm.overridden || _vm.readOnly
      },
      on: {
        "change": function($event) {
          _vm.updateSettings()
        }
      },
      model: {
        value: (_vm.minimumOrderCoinRollsSettings[index].minimumOrderCoinRoll),
        callback: function($$v) {
          _vm.$set(_vm.minimumOrderCoinRollsSettings[index], "minimumOrderCoinRoll", $$v)
        },
        expression: "minimumOrderCoinRollsSettings[index].minimumOrderCoinRoll"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "linc-text"
    }, [_vm._v(_vm._s(_vm.$t('management.unit.softwaresettings.minimumOrderPanel.max')))]), _vm._v(" "), _c('el-input', {
      staticClass: "linc-minimum-order-input",
      attrs: {
        "type": "number",
        "min": "1",
        "max": "200",
        "disabled": !_vm.overridden || _vm.readOnly
      },
      on: {
        "change": function($event) {
          _vm.updateSettings()
        }
      },
      model: {
        value: (_vm.minimumOrderCoinRollsSettings[index].maximumOrderCoinRoll),
        callback: function($$v) {
          _vm.$set(_vm.minimumOrderCoinRollsSettings[index], "maximumOrderCoinRoll", $$v)
        },
        expression: "minimumOrderCoinRollsSettings[index].maximumOrderCoinRoll"
      }
    })], 1)])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3d56a71d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/dq-ui/packages/minimumordercoinrollspanel/src/minimumordercoinrollspanel.vue
// module id = 500
// module chunks = 36